<template>
  <div :class="[`share__container`,
                (transparent) ? `share__container--transparent` : ``,
                (sharingOpen) ? `share__container--open` : ``]">
    <ul>
      <li>
         <span class="share__button" @click="toggleShare()" :style="twitterStyles"></span>
      </li>
      <li>
         <span class="share__button" @click="toggleShare()" :style="twitterStyles"></span>
      </li>
      <li>
         <span class="share__button" @click="toggleShare()" :style="twitterStyles"></span>
      </li>
    </ul>
    <span class="share__button" @click="toggleShare()" :style="shareButtonStyles"></span>

  </div>
</template>

<script>
import sharingIcon from '@/assets/images/share-icon.svg'
import sharingIconWhite from '@/assets/images/share-icon-white.svg'
import twitterIcon from '@/assets/images/twitter-icon.svg'

export default {
  props: {
    transparent: Boolean
  },
  data () {
    console.log(this.transparent)
    return {
      shareButtonStyles: {
        'background-image': `url(${(this.transparent) ? sharingIconWhite : sharingIcon})`
      },
      twitterStyles: {
        'background-image': `url(${twitterIcon})`
      },
      sharingOpen: false
    }
  },
  methods: {
    toggleShare () {
      this.sharingOpen = !this.sharingOpen
    }
  }
}
</script>
